import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, AfterViewInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FbSimpleFormComponent } from '../fb-simple-form/fb-simple-form.component';

@Component({
  selector: 'app-fb-multi-step-form',
  templateUrl: './fb-multi-step-form.component.html',
  styleUrls: ['./fb-multi-step-form.component.scss']
})
export class FbMultiStepFormComponent implements OnInit, AfterViewInit {
  @Input() steps: any[] = [];
  @Input() onBackToMasterList: () => void;
  @Input() simpleFormButton: any;
  currentStep: number = 0;
  @Input() btnClick: any
  @Input() dataFormId: any
  fields: any;
  @ViewChild("simpleForm") public simpleForm: FbSimpleFormComponent;
  showSaveNext: boolean = false;

  constructor(private cdr: ChangeDetectorRef, public router: Router, private route: ActivatedRoute, private renderer: Renderer2) { }

  ngOnInit(): void {
    console.log(this.simpleFormButton);
    console.log(this.steps);
    console.log(this.btnClick);
    //console.log('HEREE---', this.simpleForm.saveCancelBtn);
    this.steps.sort((a, b) => a.stepNumber - b.stepNumber);
  }
  ngAfterViewInit(){
    // if(this.simpleForm && this.simpleForm.saveCancelBtn?.onSaveAction?.isSaveNededOnSteps){
    //   this.showSaveNext = true;
    // }else{
    //   this.showSaveNext = false;
    // }
  }
  updateRoute(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { step: this.currentStep + 1 },
      queryParamsHandling: 'merge',
    });
  }
  onNext() {
    this.scrollToTop();
    if (this.currentStep < this.steps.length - 1) {
      this.currentStep++;
      this.updateRoute();
    }
  }
  scrollToTop(): void {
    this.renderer.setProperty(document.documentElement, 'scrollTop', 0);
    this.renderer.setProperty(document.body, 'scrollTop', 0);
  }
  onSaveNext() {
    this.simpleForm.onSave(false, this.simpleForm.saveCancelBtn.onSaveAction.pageFormId, false, 'SAVE');
    if (this.currentStep < this.steps.length - 1) {
      this.currentStep++;
      this.updateRoute();
    }
  }
  onStepLabelClick(index: number): void {
    this.currentStep = index;
    this.updateRoute();
    this.cdr.detectChanges();
  }
  onPrevious() {
    this.scrollToTop();
    if (this.currentStep > 0) {
      this.currentStep--;
      this.updateRoute();
    }
  }
  ngOnDestroy(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { step: null },
     // queryParamsHandling: 'merge',
    });
  }
}
